




















import { Component, Provide } from 'vue-property-decorator';
import BtnAddIssue from '@/components/ViewComponent/Issue/BtnAddIssue.vue';
import IssueListPc from '@/components/ViewComponent/Issue/IssueList/IssueListPc.vue';
import CSideBar from '@/components/Layout/SideBar/CSideBar.vue';
import IssueMixin from './issue.mixin';

@Component<IssuePc>({
  components: { CSideBar, IssueListPc, BtnAddIssue },
})
export default class IssuePc extends IssueMixin {
  sideDrawer: boolean = null;

  @Provide('toggleSideDrawer')
  toggleSideDrawer() {
    this.sideDrawer = !this.sideDrawer;
  }
}
